import { useEffect } from "react";
import { IRetencaoFonte } from "../../interfaces/IRetencaoFonte";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import RetencaoFonteService from "../../services/RetencaoFonteService";

const RetencaoFonteModal = ({ toggleModal, show, retencao: retencaoFonte, title }: { toggleModal: (recarregarInformacoes?: boolean) => void, show: boolean, retencao: IRetencaoFonte, title: string }) => {

  const retencaoFonteSchema = Yup.object().shape({
    codigo: Yup.string().max(50, 'Máximo 50 caracteres').required('Código é obrigatório'),
    aliquota: Yup.string().max(50, 'Máximo 50 caracteres').required('Alíquota é obrigatório').matches(/^[,0-9]+$/),
    descricao: Yup.string().max(50, 'Máximo 50 caracteres').required('Descrição é obrigatório')
  })
  const formInitialValues: IRetencaoFonte = {
    id: 0,
    codigo: '',
    aliquota: 0,
    descricao: ''
  };
  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: retencaoFonteSchema,
    onSubmit: async (retencaoFonte, { setSubmitting }) => {
      function funcaoSucesso() {
        setSubmitting(false);
        toggleModal(true);
      }
  
      if ((retencaoFonte?.id ?? 0) === 0) {
        await RetencaoFonteService.criar(retencaoFonte, funcaoSucesso, 'Retenção na Fonte foi adicionada com sucesso');
      } else {
        await RetencaoFonteService.atualizar(retencaoFonte, funcaoSucesso, 'Retenção na Fonte foi editado com sucesso');
      }
    }
  })

  useEffect(() => {
    formik.setValues(retencaoFonte);

    !retencaoFonte.codigo && formik.setFieldTouched('codigo', false);
    !retencaoFonte.aliquota && formik.setFieldTouched('aliquota', false);
    !retencaoFonte.descricao && formik.setFieldTouched('descricao', false);

    // eslint-disable-next-line
  }, [retencaoFonte]);

  return <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
    <div className="modal-content">

    <div className="modal-header">
      <h5 className="modal-title titulo-modal">{title}</h5>
      <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
        <i onClick={() => toggleModal(false)} className="fas fa-times" style={{ color: '#5E6397' }}/>
      </div>
    </div>

    <div className="modal-body">
      <form className="row g-3">
        <div className="col-md-6">
          <label htmlFor="form-codigo" className="form-label required">Cód. Retenção</label>
          <input {...formik.getFieldProps('codigo')} placeholder="Digite algo" type="text" className={clsx(
            'form-control',
            {
              'is-invalid': formik.touched.codigo && formik.errors.codigo,
            },
            {
              'is-valid': formik.touched.codigo && !formik.errors.codigo,
            }
          )} id="form-codigo" />
        </div>
        <div className="col-md-6">
          <label htmlFor="form-aliquota" className="form-label required">Alíquota</label>
          <div style={{display:'flex', border:'1px solid #E4E6EF', borderRadius:'5px'}}>
            <input {...formik.getFieldProps('aliquota')} style={{ border: 'none' }} placeholder="0" type="text" className={clsx(
            'form-control',
            {
              'is-invalid': formik.touched.aliquota && formik.errors.aliquota,
            },
            {
              'is-valid': formik.touched.aliquota && !formik.errors.aliquota,
            }
          )} id="form-aliquota" />
            <i className='icon-xl fs-3 bi bi-percent' style={{margin:'10px 10px 0 0'}}/>
          </div>
        </div>
        <div className="col-md-12">
          <label htmlFor="form-descricao" className="form-label required mt-5">Descrição Retenção</label>
          <input {...formik.getFieldProps('descricao')} placeholder="Digite algo" type="text" className={clsx(
            'form-control',
            {
              'is-invalid': formik.touched.descricao && formik.errors.descricao,
            },
            {
              'is-valid': formik.touched.descricao && !formik.errors.descricao,
            }
          )} id="form-descricao" />
        </div>
      </form>
    </div>

    <div className="modal-footer" style={{ margin: '0 auto' }}>
      <button disabled={formik.isSubmitting} onClick={() => toggleModal(false)} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
      <button disabled={formik.isSubmitting || !formik.isValid} onClick={async () => await formik.submitForm()} type="button" className="btn btn-primario ms-5">
        { !formik.isSubmitting && ((retencaoFonte?.id ?? 0) === 0 ? 'ADICIONAR' : 'EDITAR') }
        {
          formik.isSubmitting && (
          <span className='indicator-progress' style={{ display: 'block' }}>
              Salvando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        )}
      </button>
    </div>
  </div>
</Modal>
}

export default RetencaoFonteModal;